import React from 'react';
import PropTypes from 'prop-types';
import css from './Timeline.module.scss';

const Timeline = ({children, className}) => {
  return (
    <ol className={[css.timeline, className].filter(Boolean).join(' ')}>
      {children}
    </ol>
  );
};

Timeline.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Timeline;
